<template>
  <form-group-thux-horizontal
    :validator="validator"
    :label="labelForm | translate"
    :label-class="labelFormClass"
    :label-cols-sm="labelColsSm"
    :label-cols-lg="labelColsLg"
    :class="classForm"
    :external-errors="externalErrors"
    :disabled="disabled"
  >
    <template slot-scope="{ attrs, listeners }">
      <b-form-file
        v-bind="attrs"
        v-on="listeners"
        v-model="model"
        class="mb-2"
        :placeholder="placeholder"
        :drop-placeholder="dropPlaceholder"
        :disabled="disabled"
      />
    </template>
  </form-group-thux-horizontal>
</template>

<script>
export default {
  name: 'form-file-thux',
  props: {
    // FORM FIELDS
    validator: {},
    labelForm: { required: true },
    labelColsSm: { default: 2 },
    labelColsLg: { default: 2 },
    labelFormClass: {},
    classForm: {},
    externalErrors: {},

    // TEXT AREA FIELDS
    disabled: { default: false },
    value: { required: true },
    classFile: {},
    placeholder: {},
    dropPlaceholder: {}
  },
  watch: {
    value () {
      this.$set(this, 'model', this.value)
    },
    model () {
      this.$emit('input', this.model)
    }
  },
  data () {
    return {
      model: ''
    }
  },
  created () {
    this.$set(this, 'model', this.value)
  }
}
</script>
